import { render, staticRenderFns } from "./FooterComponent.vue?vue&type=template&id=4a3832b4&scoped=true&"
import script from "./FooterComponent.vue?vue&type=script&lang=js&"
export * from "./FooterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3832b4",
  null
  
)

export default component.exports